import $ from 'jquery';

const toggleList = () => {
    if ($('.js-benefits>div:eq(6)').hasClass('d-none')) {
        $('.js-benefits>div:gt(5)')
            .finish()
            .css({ opacity: 0 })
            .removeClass('d-none')
            .addClass('d-flex')
            .animate({ opacity: 1 }, 250);
    } else {
        $('.js-benefits>div:gt(5)')
            .finish()
            .animate({ opacity: 0 }, 250, () => {
                $('.js-benefits>div:gt(5)').removeClass('d-flex').addClass('d-none')
            });
    }
};

$('.js-benefits-more').on('click', e => {
    e.preventDefault();
    $(e.currentTarget).find('span').toggle();
    $(e.currentTarget).find('svg').toggleClass('to_up');
    toggleList();
    setTimeout(() => {
        $(e.currentTarget).toggleClass('active');
    },500)
});

$(document).on('click', '.js-benefits-more.active', e =>  {
    e.preventDefault();
    $("html, body").animate({ scrollTop: $('.js-benefits').offset().top }, 500);
});
